import { render } from "./BurofaxTemplatePreviewPageSettings.vue?vue&type=template&id=31e8b08a"
import script from "./BurofaxTemplatePreviewPageSettings.vue?vue&type=script&lang=js"
export * from "./BurofaxTemplatePreviewPageSettings.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__